import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ToastTypes, withToast } from "../../contexts/toastr.context";
import { withWeb3 } from "../../contexts/web3.context";
import RPC from "../../web3RPC"; // for using web3.js
import { AuthService, UserService } from "../../_service";
import { createSession } from "../../_store/_actions/auth.actions";
import "../../_styles/web-auth.style.scss";
import { CustomLoginButton } from "./auth-chooser.login-page";

const clientId = process.env.REACT_APP_WEB3_CLIENT_ID; // get from https://dashboard.web3auth.io

function Web3AuthButtonComponent({
  // context
  addToast,
  // web3
  web3auth,
  setWeb3auth,
  provider,
  setProvider,
  getWeb3Accounts,
  // dispatch
  setUser,
}) {
  const [isFullPage, setIsFullPage] = useState(true);

  const [web3User, setWeb3User] = useState(null);

  // get user info from provider
  useEffect(() => {
    if (provider && web3auth) {
      // get the user info
      getWeb3User();
    }
  }, [provider, web3auth]);

  useEffect(() => {
    // logout();
    generatePensilToken();
  }, [web3User]);

  const getWeb3User = async () => {
    const userInfo = await web3auth.getUserInfo();
    setWeb3User(web3auth ? userInfo : null);
  };

  const generatePensilToken = async () => {
    const user = web3User;
    if (user) {
      console.log("REDDDDD", user);
      const { email, name, idToken, profileImage } = user;

      if (idToken) {
        if (!email) {
          addToast(
            "Please try a different method",
            "Could not find any email address on the current method!",
            ToastTypes.danger
          );
          return;
        }
        // send the id token to server
        const response = await AuthService.web3Login(user.idToken);
        // update wallet address
        const walletAddress = await getWeb3Accounts();
        // logged in
        const newUserObject = {
          ...response.user,
          walletAddress,
        };
        // save the user
        localStorage.setItem("pensil.user", JSON.stringify(newUserObject));
        if (walletAddress) {
          UserService.updateWalletAddress(walletAddress);
        }
        // set the user data
        setUser(newUserObject);
      } else {
        addToast(
          "Please try a different method",
          "External wallet connect is not supported!",
          ToastTypes.danger
        );
        // log out user from web3
        await logout();
        return;
      }
    }
  };

  const login = async () => {
    if (!web3auth) {
      uiConsole("web3auth not initialized yet");
      return;
    }
    const web3authProvider = await web3auth.connect();
    setProvider(web3authProvider);
  };

  const authenticateUser = async () => {
    if (!web3auth) {
      uiConsole("web3auth not initialized yet");
      return;
    }
    const idToken = await web3auth.authenticateUser();
    uiConsole(idToken);
  };

  const getUserInfo = async () => {
    if (!web3auth) {
      uiConsole("web3auth not initialized yet");
      return;
    }
    const user = await web3auth.getUserInfo();
    uiConsole(user);
  };

  const logout = async () => {
    if (!web3auth) {
      uiConsole("web3auth not initialized yet");
      return;
    }
    await web3auth.logout();
    setProvider(null);
  };

  const getChainId = async () => {
    if (!provider) {
      uiConsole("provider not initialized yet");
      return;
    }
    const rpc = new RPC(provider);
    const chainId = await rpc.getChainId();
    uiConsole(chainId);
  };
  const getAccounts = async () => {
    if (!provider) {
      uiConsole("provider not initialized yet");
      return;
    }
    const rpc = new RPC(provider);
    const address = await rpc.getAccounts();
    uiConsole(address);
  };

  const getBalance = async () => {
    if (!provider) {
      uiConsole("provider not initialized yet");
      return;
    }
    const rpc = new RPC(provider);
    const balance = await rpc.getBalance();
    uiConsole(balance);
  };

  const sendTransaction = async () => {
    if (!provider) {
      uiConsole("provider not initialized yet");
      return;
    }
    const rpc = new RPC(provider);
    const receipt = await rpc.sendTransaction();
    uiConsole(receipt);
  };

  const signMessage = async () => {
    if (!provider) {
      uiConsole("provider not initialized yet");
      return;
    }
    const rpc = new RPC(provider);
    const signedMessage = await rpc.signMessage();
    uiConsole(signedMessage);
  };

  // const getPrivateKey = async () => {
  // 	if (!provider) {
  // 		uiConsole('provider not initialized yet');
  // 		return;
  // 	}
  // 	const rpc = new RPC(provider);
  // 	const privateKey = await rpc.getPrivateKey();
  // 	uiConsole(privateKey);
  // };

  function uiConsole(...args) {
    const el = document.querySelector("#console>p");
    if (el) {
      el.innerHTML = JSON.stringify(args || {}, null, 2);
    }
  }

  const loggedInView = (
    <>
      <div className="flex-container">
        <div>
          <button onClick={getUserInfo} className="card">
            Get User Info
          </button>
        </div>
        <div>
          <button onClick={authenticateUser} className="card">
            Get ID Token
          </button>
        </div>
        <div>
          <button onClick={getChainId} className="card">
            Get Chain ID
          </button>
        </div>
        <div>
          <button onClick={getAccounts} className="card">
            Get Accounts
          </button>
        </div>
        <div>
          <button onClick={getBalance} className="card">
            Get Balance
          </button>
        </div>
        <div>
          <button onClick={signMessage} className="card">
            Sign Message
          </button>
        </div>
        <div>
          <button onClick={sendTransaction} className="card">
            Send Transaction
          </button>
        </div>
        {/* <div>
					<button onClick={getPrivateKey} className='card'>
						Get Private Key
					</button>
				</div> */}
        <div>
          <button onClick={logout} className="card">
            Log Out
          </button>
        </div>
      </div>
      <div id="console" style={{ whiteSpace: "pre-line" }}>
        <p style={{ whiteSpace: "pre-line" }}>Login Successful</p>
      </div>
    </>
  );

  return (
    <div className="container">
      <div className="grid">
        {provider ? (
          <></>
        ) : (
          <CustomLoginButton label="Start here" onClick={login}>
            Login
          </CustomLoginButton>
        )}
      </div>
      {/* <Web3ChromeExtensionLink /> */}
    </div>
  );
}

function Web3ChromeExtensionLink() {
  return (
    <h1 className="title">
      <a target="_blank" href="http://web3auth.io/" rel="noreferrer">
        Web3Auth{" "}
      </a>
      Chrome Extension
    </h1>
  );
}

const mapStateToProps = (state) => ({
  community: state.community,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setUser: createSession,
    },
    dispatch
  );

const Web3AuthButton = connect(
  mapStateToProps,
  mapDispatchToProps
)(withWeb3(withToast(Web3AuthButtonComponent)));

export default Web3AuthButton;
